import { NULL_LINK } from '../constants';
import { createMailTo } from './utils'

function isValidFullSlug(link) {
  return typeof link == 'string' && link[0] !== '/';
}

function parseStoryblokLink(link, fallbackValue) {
  if (!parseStoryblokLink.isValidUrl(link)) {
    return fallbackValue !== undefined ? fallbackValue : NULL_LINK;
  }

  if (link.email) {
    return createMailTo(link.email, link);
  }

  if (link.url) {
    return link.url;
  }


  if (link.cached_url) {
    return '/' + link.cached_url;
  }

  return `/${link}`;
}

parseStoryblokLink.isValidUrl = function (link) {
  return (
    link && (link.url || link.email || link.cached_url || isValidFullSlug(link))
  );
};

export default parseStoryblokLink;
